import { render, staticRenderFns } from "./mDouble.vue?vue&type=template&id=20747cf8&scoped=true&"
import script from "./mDouble.vue?vue&type=script&lang=js&"
export * from "./mDouble.vue?vue&type=script&lang=js&"
import style0 from "./mDouble.vue?vue&type=style&index=0&id=20747cf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20747cf8",
  null
  
)

export default component.exports